import { DateTime } from 'luxon';
import { capitalize } from 'vue';

import PackageRestrictions from '@/common/models/package/PackageRestrictions.enum';
import { Filter, FilterComparisonOperator, FilterLogicalOperator } from '@/common/models/query-params';
import { toServerDateTimeNoTimezone } from '@/globals';
import i18n from '@/vueI18n';

import PackageStatus from './PackageStatus.enum';

interface IPackageOption {
  value: string;
  name: string;
  logicalOperator?: FilterLogicalOperator;
  filters?: Filter[];
}

export default class PackageOptions {
  static getLocalizedOptionName(name: string): string {
    return capitalize(i18n.global.t(`states.${name}`));
  }

  static packageRestrictionOptions(): IPackageOption[] {
    return [
      {
        value: PackageRestrictions.OPEN,
        name: 'Open',
      },
      {
        value: PackageRestrictions.PRIVATE,
        name: 'Private',
      },
    ];
  }

  static demandStatusOptions(): unknown[] {
    return [];
  }

  static supplyStatusOptions(): IPackageOption[] {
    return [
      {
        value: PackageStatus.Draft,
        name: PackageOptions.getLocalizedOptionName('draft'),
      },
      {
        value: PackageStatus.Retired,
        name: PackageOptions.getLocalizedOptionName('retired'),
      },
      {
        value: 'COMPLETED',
        name: PackageOptions.getLocalizedOptionName('completed'),
        logicalOperator: FilterLogicalOperator.AND,
        filters: [
          new Filter('state', [PackageStatus.Published]),
          new Filter(
            'flight_to',
            [toServerDateTimeNoTimezone(DateTime.local().startOf('day'))],
            FilterComparisonOperator.LESS_THAN,
          ),
        ],
      },
      {
        value: PackageStatus.Published,
        name: PackageOptions.getLocalizedOptionName('live'),
        logicalOperator: FilterLogicalOperator.AND,
        filters: [
          new Filter('state', [PackageStatus.Published]),
          new Filter(
            'flight_to',
            [toServerDateTimeNoTimezone(DateTime.local().startOf('day'))],
            FilterComparisonOperator.GREATER_THAN_OR_EQUAL,
          ),
          new Filter(
            'flight_from',
            [toServerDateTimeNoTimezone(DateTime.local().startOf('day'))],
            FilterComparisonOperator.LESS_THAN_OR_EQUAL,
          ),
        ],
      },
      {
        value: 'UPCOMING',
        name: PackageOptions.getLocalizedOptionName('upcoming'),
        logicalOperator: FilterLogicalOperator.AND,
        filters: [
          new Filter('state', [PackageStatus.Published]),
          new Filter(
            'flight_from',
            [toServerDateTimeNoTimezone(DateTime.local().startOf('day'))],
            FilterComparisonOperator.GREATER_THAN,
          ),
        ],
      },
    ];
  }

  static demandDefaultStatusOptions(): unknown[] {
    return [];
  }

  static supplyDefaultStatusOptions(): unknown[] {
    return [];
  }
}
